/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETPROJECTBID= createAsyncThunk(
  "getProjectById/getProjectById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getProjectByIdSlice = createSlice({
  name: "getProjectByIdSlice",
  initialState: {
    getProjectById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetProjectById: (state) => {
        state.getProjectById.loading = false
        state.getProjectById.error = false
        state.getProjectById.data = []
        state.getProjectById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETPROJECTBID.fulfilled, (state, action) => {
      state.getProjectById = {
        ...state.getProjectById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPROJECTBID.pending, (state, action) => {
      state.getProjectById = {
        ...state.getProjectById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPROJECTBID.rejected, (state, action) => {
      state.getProjectById = {
        ...state.getProjectById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getProjectByIdAction = {
    GETPROJECTBID,
};

export { getProjectByIdAction };
export default getProjectByIdSlice.reducer;
export const {setInitialStateOfgetProjectById} = getProjectByIdSlice.actions